import script from "./AcquisitionMethod.vue?vue&type=script&setup=true&lang=js"
export * from "./AcquisitionMethod.vue?vue&type=script&setup=true&lang=js"

import "./AcquisitionMethod.vue?vue&type=style&index=0&id=0e1ccede&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e1ccede"]])

export default __exports__